import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasModal = ({ open, onClose, children, className, disableEscapeKeyDown, sx, ...props }) => {
  useEffect(() => {
    if (!open) return
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && !disableEscapeKeyDown) onClose?.()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, disableEscapeKeyDown, onClose])

  if (!open) return null
  return (
    <div className='fixed inset-0 z-50'>
      {/* Backdrop — click anywhere on it to dismiss */}
      <div className='fixed inset-0 bg-black/50' onClick={() => onClose?.()} />
      {/* Content centering layer — pointer-events-none so clicks pass through to backdrop */}
      <div className='fixed inset-0 flex items-center justify-center pointer-events-none'>
        <div className={cn('relative pointer-events-auto rounded-card bg-white shadow-xl', className)} {...props}>
          {children}
        </div>
      </div>
    </div>
  )
}

AdasModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  disableEscapeKeyDown: PropTypes.bool
}
